import axios from 'axios';
import Metadata from '../helpers/metadata/Metadata';
import serviceUtil from './serviceUtil';
import recordDescriptorProcessing  from '../helpers/StoreFunctions/recordDescriptorProcessing';
import _ from 'lodash';

// Request deduplication cache
const requestCache = new Map();

let helpers = {
  getCompanies(options, companyOverride, searchString) {
    let filter = '';
    if (options && options.recordDescriptor) {
      filter = '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }
    
    const url = process.env.REACT_APP_API + '/companies/?current_company=' + (companyOverride ? companyOverride.id : localStorage.current_company_id) + '&keywords=' + (searchString ? searchString : '') + filter;
    
    // Check if identical request is already in progress
    const cacheKey = url;
    if (requestCache.has(cacheKey)) {
      return requestCache.get(cacheKey);
    }
    
    const requestPromise = axios({
      method: 'get',
      url: url,
      timeout: 120000, headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        // Remove from cache when request completes
        requestCache.delete(cacheKey);
        return response.data;
      })
      .catch(error => {
        // Remove from cache when request fails
        requestCache.delete(cacheKey);
        return serviceUtil.resultForError(error);
      });
    
    // Store the promise in cache
    requestCache.set(cacheKey, requestPromise);
    
    return requestPromise;
  },
  ///
  /// There is only one admin company. It is the company the super users belong to--the api will now
  /// return it as a single
  ///
  getAdminCompany(options) {
    let filter = '';
    if (options && options.recordDescriptor) {
      filter = '?filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }
    return axios({
      method: 'get',
      url: process.env.REACT_APP_API + '/admin/companies' + filter,
      timeout: 20000, headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
      data: {
        user: {  
          id: localStorage.loggedin_user_id,
        },
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  getCompany(company_id, options) {
    if (!company_id) {
      return Promise.resolve(serviceUtil.resultForErrorText('company id not set'));
    }
    let url = process.env.REACT_APP_API + '/companies/' + company_id + '?current_company=' + localStorage.current_company_id;
    if (options && options.recordDescriptor) {
      url +=  '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }
    return axios({
      method: 'get',
      url: url,
      timeout: 20000, headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  createCompany(company, eventMetadatum) {
    const contact = company.concact;
    const admin = company.admin;
    delete company.contact;
    delete company.admin;
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({  
      method: 'post',
      url: process.env.REACT_APP_API + '/admin/companies?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
        company: company,
        contact: contact ? contact.id : null,
        admin: admin ? admin.id : null,
      },
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  createVendorCompany(company, eventMetadatum) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'post',
      url: process.env.REACT_APP_API + '/companies/create_vendor?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
        vendor_company_id: company.id,
      },
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  deleteVendorCompany(company, eventMetadatum) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'delete',
      url: process.env.REACT_APP_API + '/companies/' + company.id + '/remove_vendor?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
      },
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  updateCompany(company, eventMetadatum) {
    const contact = company.contact;
    const admin = company.admin;
    const companyId = company.id;
    company = _.pick(company, ['name','logo','logoUpdated','accent_color','country','address_1','address_2','city','state','zip','features']);
    if (!company.logoUpdated) {
      delete company.logo;
    }
    else{
      delete company.logoUpdated;
    }
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'patch',
      url: process.env.REACT_APP_API + '/companies/' + companyId + '?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
        company: company,
        contact: contact ? contact.id : null,
        admin: admin ? admin.id : null,
      },
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  deleteAdmin(admin, company_id, eventMetadatum) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'delete',
      url: process.env.REACT_APP_API + '/companies/' + company_id + '/remove_admin?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
        admin: admin ? admin.id : null,
      },
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  deleteContact(contact, company_id, eventMetadatum) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'delete',
      url: process.env.REACT_APP_API + '/companies/' + company_id + '/remove_contact?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
        contact: contact ? contact.id : null,
      },
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  updateCompanyAdmin(company, eventMetadatum) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    const contact = company.contact;
    const admin = company.admin;
    delete company.contact;
    delete company.admin;
    if (!company.logoUpdated) {
      delete company.logo;
    }
    else {
      delete company.logoUpdated;
    }
    return axios({
      method: 'patch',
      url: process.env.REACT_APP_API + '/admin/companies/' + company.id + '?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
        company: company,
        contact: contact ? contact.id : null,
        admin: admin ? admin.id : null,
      },
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return this.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  deleteCompanyAdmin(company_id, eventMetadatum) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'delete',
      url: process.env.REACT_APP_API + '/admin/companies/' + company_id + '?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
      },
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  getWhiteLabels(company_id) {
    return axios({
      method: 'get',
      url: process.env.REACT_APP_API + '/white_labels/',
      timeout: 20000, headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        const whiteLabels = response.data.filter(whiteLabel => {
          return whiteLabel.company_id == company_id;
        });
        return whiteLabels;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  getWhiteLabel(id) {
    return axios({
      method: 'get',
      url: process.env.REACT_APP_API + '/white_labels/' + id,
      timeout: 20000, headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data.white_label;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  getWhiteLabelByField(field) {
    return axios({
      method: 'get',
      url: process.env.REACT_APP_API + '/white_labels-by-field/' + field,
      timeout: 20000, headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data.white_label;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  createWhiteLabel(white_label, eventMetadatum) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'post',
      url: process.env.REACT_APP_API + '/white_labels/',
      data: {
        event_metadatum: eventMetadatum,
        white_label: white_label,
      },
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data.white_label;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  updateWhiteLabel(white_label, eventMetadatum) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'patch',
      url: process.env.REACT_APP_API + '/white_labels/' + white_label.id,
      data: {
        event_metadatum: eventMetadatum,
        white_label: white_label,
      },
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  updateWhiteLabelByField(white_label, eventMetadatum) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'patch',
      url: process.env.REACT_APP_API + '/white_labels-by-field/' + white_label.field,
      data: {
        event_metadatum: eventMetadatum,
        white_label: white_label,
      },
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  deleteWhiteLabel(id, eventMetadatum) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'delete',
      url: process.env.REACT_APP_API + '/white_labels/' + id,
      data: {
        event_metadatum: eventMetadatum,
      },
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },

  updateAPIKey(companyId, eventMetadatum) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'post',
      url: process.env.REACT_APP_API + '/admin/companies/' + companyId + '/generate_api_key',
      timeout: 20000,
      data: {
        event_metadatum: eventMetadatum,
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
};

export default helpers;



// WEBPACK FOOTER //
// ./src/services/companiesService.js